import * as Scrivito from "scrivito";
import { isLiv } from "^/utils/isLiv";
import { EditorHintForPageChanges } from "./EditorHintForPageChanges";
import { LdapSyncMessages } from "./LdapSyncMessages";

// this component notifies the editor that some of ContactPages have been deactivated via LDAP system
function Notifier() {
  return (
    <div className="page-hints">
      {!isLiv() && <LdapSyncMessages />}
      <EditorHintForPageChanges show={Scrivito.isInPlaceEditingActive()} />
    </div>
  );
}

export default Scrivito.connect(Notifier);
